<template>
    <div>

        <div class="container-fluid">
            <div class="row">

                <div class="col-12 white rounded" style="padding: 10px; margin: 5px">
                    <div class="container-fluid">
                        <div class="row">

                            <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                <toggle-button tabindex="21" @change="getDinero" v-model="tipoTiempoAntes" color="#e3985f" :width="150" :height="40" :labels="{checked: 'Completo', unchecked: 'medioDia'}"/>
                            </div>

                            <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                <datepicker :monday-first="true" :language="es" @input="getDinero" v-model="date" format-date="dd/MM/yyyy"></datepicker>
                            </div>

                            <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                <toggle-button @change="getDinero" tabindex="21" v-model="tipoTiempo" color="#e3985f" :width="150" :height="40" :labels="{checked: 'Completo', unchecked: 'medioDia'}"/>
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
                                <toggle-button @change="getDinero" tabindex="20" v-model="web" color="#e3985f" :width="150" :height="40" :labels="{checked: 'Córdoba', unchecked: 'Sevilla'}"/>
                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <v-select @change="getDinero"
                                        v-model="empleado"
                                        :items="empleados"
                                        label="Empleado:"
                                        outline
                                ></v-select>
                            </div>
                        </div>
                        <div class="row">

                            <p>Pendiente de recoger: <strong>{{totalRecogida}} €</strong></p>

                        </div>

                        <div class="clearfix"></div>

                        <hr>

                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <h2>Sevilla</h2>

                                <div v-for="item in toursSevilla" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                            {{item.nombre}}
                                        </div>

                                        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">

                                            <select class="form-control" v-model="item.tipo">
                                                <option value="0">Mañana</option>
                                                <option value="1">Tarde</option>
                                            </select>




                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <h2>Córdoba</h2>
                                <div v-for="item in toursCordoba" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                            {{item.nombre}}
                                        </div>

                                        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">

                                            <select class="form-control" v-model="item.tipo">
                                                <option value="0">Mañana</option>
                                                <option value="1">Tarde</option>
                                            </select>




                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                            <div class="container-fluid">
                                <div class="row">

                                </div>
                            </div>


                        <div class="row" style="margin-top: 20px">

                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">

                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <span class="btn btn-success" v-on:click="guardarDatos">Guardar Datos</span>
                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">

                            </div>



                        </div>

                    </div>
                </div>
            </div>
            <div class="clearfix"></div>

        </div>




    </div>

</template>

<script>

//import MonthPicker from 'vue-month-picker'
import axios from 'axios'
import LineChart from './personasMes.js'
import { ToggleButton } from 'vue-js-toggle-button'
import Datepicker from 'vuejs-datepicker';
import {en, es} from 'vuejs-datepicker/dist/locale'

//axios.defaults.baseURL = 'http://localhost/FreeTourControl/api'
axios.defaults.baseURL = 'https://app.freetoursevilla.es/api'

export default {
    components: {
        LineChart,
      ToggleButton,
      Datepicker
    },
  data () {
    return {

      date: new Date(),
      es: es,
      precision:2,

      personas:0,
      economico:'',

      web: false,//false es sevilla y true es cordoba
      tipoTiempoAntes: false,//false es medioa dia y true es completo
      tipoTiempo: false,//false es medioa dia y true es completo
      empleados:[],
      empleado:"",

      toursSevilla:[],
      toursCordoba:[],

      totalRecogida:0

      }
  },
    created() {
        this.getEmpleados();
        this.getOpcionesTours();
    },
    mounted () {


    },
  methods: {
        getDinero(){
          let formData = new FormData();

          formData.append('fechaDesde', this.date.getFullYear()+"-"+(this.date.getMonth()+1)+"-"+this.date.getDate());
          formData.append('empleado', this.empleado);
          formData.append('tipoTiempoAntes', this.tipoTiempoAntes);
          formData.append('tipoTiempo', this.tipoTiempo);
          formData.append('web', this.web);


          axios.post('/get.dinero.php', formData)
            .then(response => {

              this.totalRecogida = response.data;

            })
            .catch(error => {
              console.log(error);
            })







        },
        guardarDatos(){

          let formData = new FormData();

          formData.append('toursSevilla', JSON.stringify(this.toursSevilla));
          formData.append('toursCordoba', JSON.stringify(this.toursCordoba));

          axios.post('/save.opciones.tours.php', formData)
            .then(response => {

              alert("GUARDADO");

            })
            .catch(error => {
              console.log(error);
            })



        },
        filtroWeb(){


          this.getEmpleados();

        },
        getEmpleados(){
        let formData = new FormData();

        formData.append('month', this.date.getMonth()+1);
        formData.append('year', this.date.getFullYear());

        formData.append('web', this.web);

        axios.post('/get.empleados.dato.php', formData)
            .then(response => {

                this.empleados = response.data;
                this.empleado = response.data[0];




            })
            .catch(error => {
                console.log(error);
            })

    },
        getOpcionesTours(){

            axios.post('/getTours.php')
                .then(response => {

                    this.toursSevilla = response.data.sevilla;
                    this.toursCordoba = response.data.cordoba;




                })
                .catch(error => {
                    console.log(error);
                })

        },
        complete (index) {
          this.list[index] = !this.list[index]
        }
  }
}
</script>
<style>
    .month-picker-input-container{
        width: 100% !important;
    }
    .month-picker-input{
        background-color: #FFF;
        width: 100% !important;
    }
    .month-picker-container{
        background-color: #FFF;
        z-index: 99998;
        width: 100% !important;
    }
    .month-picker-container button{
        background-color: #FFF;
        z-index: 99999;
    }
    .month-picker-container button:hover{
        background-color: #FFF;
        z-index: 99999;
    }
    .fondoBlanco{
        background-color: #fff;

        border-color: #fff;

        color: rgba(0,0,0,.87);
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);

        border-radius: 3px;
    }
</style>